exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".generic-itransact{padding:30px}.generic-itransact .instructions{font-size:.9rem}.generic-itransact .payment-source{font-size:1rem;margin-bottom:16px;display:flex;align-items:center}.generic-itransact .payment-source:last-of-type{margin-bottom:0}.generic-itransact .payment-source .label-wrapper{padding-top:0}.generic-itransact .payment-source svg{width:24px;height:24px;margin-right:10px;fill:#285480}.generic-itransact .payment-source .select-button{margin-right:10px}.generic-itransact .add-button{font-size:.85rem;margin-top:20px}.generic-itransact .add-button svg{margin-right:10px;width:18px;height:18px}.generic-itransact .delete-method-button{margin-left:auto;padding:4px 5px 3px}.generic-itransact .delete-method-button svg{fill:#d62027;margin:0;width:22px;height:22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Payroc/PayrocGenericModal.scss
// module id = 865
// module chunks = 0